import React from "react";
import { Redirect, Route, RouteProps, Switch } from "react-router-dom";
import { HomeBuilderLogin } from "../../containers/Login";
// import { Profile } from "../../containers/Profile";
import { TenantUser } from "../../containers/TenantUser";
import { LayoutDashboard } from "../../../components";
import { TenantUserProvider } from "../../../usecases/TenantUser";
import { useAuthState } from "../../../usecases/Auth";
// import { CompanyProfile } from "../../containers/CompanyProfile";
// import { TenantProvider } from "../../../usecases/Tenant";
import { RouteInfos } from "../../../common/routeInfo";
import { HomeProvider } from "../../../usecases/Home";
import { Homes } from "../../containers/Home";
// import { Homebuyer } from "../../containers/Homebuyer";
// import { HomebuyerProvider } from "../../../usecases/Homebuyer";
import { useSettingState } from "../../../usecases/Setting";
import { MaterialProvider } from "../../../usecases/Material";
import { Material } from "../../containers/Material";
import { ProductProvider } from "../../../usecases/Product";
import { Product } from "../../containers/Product";
import { HomeConfiguration } from "../../containers/HomeConfiguration";
import { ThemeConfig } from "../../containers/ThemeConfig";

type HomeBuilderRoutePropsType = React.PropsWithChildren<RouteProps>;

const HomeBuilderRoute: React.FC<HomeBuilderRoutePropsType> = ({
  children,
  ...rest
}: HomeBuilderRoutePropsType) => {
  const authState = useAuthState();

  const onRenderHandle = React.useCallback(
    ({ location }) => {
      if (authState.userInfo) {
        return children;
      } else {
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        );
      }
    },
    [authState, children],
  );

  return <Route {...rest} render={onRenderHandle} />;
};

const HomeBuilderRouterComponent: React.FC = () => {
  const authState = useAuthState();
  const settingState = useSettingState();

  console.info(authState.userInfo);
  return (
    <Switch>
      <Route path={`/login`}>
        <HomeBuilderLogin />
      </Route>
      <HomeBuilderRoute path="/">
        <LayoutDashboard
          profileFirstName={authState.userInfo?.attributes?.given_name || ""}
          profileLastName={authState.userInfo?.attributes?.family_name || ""}
          profileImage={authState.userInfo?.attributes["custom:avatarUrl"]}
          logoImage={settingState.tenantInfo?.tenantLogoImage}
          role={authState.userInfo?.group}
        >
          <Switch>
            <Route path={RouteInfos.Homes.path}>
              <HomeProvider>
                <Homes />
              </HomeProvider>
            </Route>
            <Route path={"/tenantUsers"}>
              <TenantUserProvider>
                <TenantUser />
              </TenantUserProvider>
            </Route>
            <Route path={`/materials`}>
              <MaterialProvider>
                <Material />
              </MaterialProvider>
            </Route>
            <Route path={`/products`}>
              <ProductProvider>
                <Product />
              </ProductProvider>
            </Route>
            <Route path={RouteInfos.HomeConfigurations.path}>
              <ProductProvider>
                <HomeConfiguration />
              </ProductProvider>
            </Route>
            <Route path={RouteInfos.ThemeConfig.path}>
              <ThemeConfig />
            </Route>
            {/* <Route path={"/homebuyer"}>
              <HomebuyerProvider>
                <Homebuyer />
              </HomebuyerProvider>
            </Route> */}
            {/* <Route path={"/profile"}>
              <Profile />
            </Route>
            <Route path={"/companyProfile"}>
              <TenantProvider>
                <CompanyProfile />
              </TenantProvider>
            </Route> */}
            <Route exact path={"/"}>
              <Redirect to="/materials" />
            </Route>
          </Switch>
        </LayoutDashboard>
      </HomeBuilderRoute>
    </Switch>
  );
};

export const HomeBuilderRouter = React.memo(HomeBuilderRouterComponent);
